import React from 'react';
import { PropagateLoader } from 'react-spinners';

// import '../styles/page-center.css';

const LoadingSpinner = () => {
  return (<div className="flex-container">
      <div className="flex-row">
        <div className="flex-item">
          <PropagateLoader
              color={'#123abc'}
              loading />
        </div>
      </div>
    </div>);
};

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.js